import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import M_Footer from './M_Footer';
import { Link } from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import {CustomAlert,CustomAlert2,CustomAlert3, CustomAlert_x,instance} from './common';

function inputsCheck(inputs){
    let isCheck = false;
    let check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
    if(check.test(inputs)){
        isCheck = true;
    }

    if(inputs.length != 13){
        isCheck = true;
    }
    console.log('isCheck : ', isCheck);
    return isCheck;
}
function checkNum(inputs,popup,setPopup){
    let isCheck = inputsCheck(inputs)
    if(!isCheck){
        const session = JSON.parse(window.sessionStorage.result);
        const {u_type} = session;
        
        let obj = {co_number:inputs,u_type:u_type}
        console.log('obj : ',obj)
        const fetchData = async () => {
            instance.post('/contract/number',obj).then(function(res){
                
                if(res.data.msg == 'nodata'){
                    setPopup({
                        ...popup,
                        no:true,
                    });
                }else if(res.data.msg == 'exist'){
                    setPopup({
                        ...popup,
                        ex:true,
                    });
                }else{
                    // console.log('res data rows[0]: ', res);
                    let {co_pro,co_discount} = res.data.rows[0];
                    updateNum(inputs,co_pro,co_discount,popup,setPopup);
                }
            });
            
        };
    
        fetchData();
    }else{
        setPopup({
            ...popup,
            format:true,
        });
    }
   
    
}


function updateNum(inputs,co_pro,co_discount,popup,setPopup){
    const session = JSON.parse(window.sessionStorage.result);
    const {u_login_id,u_type} = session;
    let obj;
    if(u_type === '일반고객' || u_type === '총판' || u_type === '클라이언트'){
        obj = {co_user_id:u_login_id}
    }else if(u_type == '카마스터'){
        obj = {co_user_id2:u_login_id,is_use:1}
    }else if(u_type == '시공지점'){
        obj = {co_user_id2:u_login_id,is_use:1}
    }


    let valueObj = {
        obj:obj,
        whereField:'co_number',
        whereValue:inputs
    }
    
    const fetchData = async () => {
        instance.post('/contract/update',valueObj).then(function(res){
            if(u_type === '일반고객' || u_type === '총판' || u_type === '클라이언트'){
                if(co_pro === 1){
                    setPopup({
                        ...popup,
                        ok:true,
                        pro:1,
                        co_discount:co_discount
                    });
                    
                }else if(co_pro === 0){
                    setPopup({
                        ...popup,
                        ok:true,
                        pro:0
                    });
                }
            }else if(u_type == '카마스터' || u_type == '시공지점'){
                if(co_pro == 1){
                    //alert('프로모션 대상 고객 계약번호 입니다.\n결제 단계를 건너뜁니다.');
                    setPopup({
                        ...popup,
                        ok:true,
                        pro:1,
                        co_discount:co_discount
                    });
                    
                }else if(co_pro == 0){
                    setPopup({
                        ...popup,
                        ok:true,
                        pro:0
                    });
                }
                //alert('정상적으로 차량추가가 되었습니다.\n차량정보에서 확인 해보세요.');
            }
            
        });
        
    };

    fetchData();
    
}


function RepInsert({history, location, match}) {

    

    const query = queryString.parse(location.search);
    let date = query.date;
    let r_id = query.r_id;
    let si_id = query.si_id;

    const [promotionText, setText] = useState('계약번호');

    useLayoutEffect(() => {
        instance.post('/reserve/r_id' , {r_id:r_id}).then(function(res){     
            if(res.data[0].s_id){
                if(JSON.parse(res.data[0].s_id)[0].s_cate === '썬가드하이퍼이벤트'){
                    setText('차대번호');
                }
            }

        });
    }, [])
    const [inputs, setInputs]  = useState('');


    const [popup, setPopup] = useState({
        ok:false,
        no:false,
        ex:false,
        format:false,
        pro:0,
        co_discount:''
    });

    const {ok,no,ex,pro,format,co_discount} = popup;
    const goBack = () => {
        history.goBack();
    };

    

    const onClick = () => {
        checkNum(inputs,popup,setPopup);
        
    }

    const onChange = (e) => {

        const {name,value} = e.target;

        setInputs(value);
        
    }
        
        



  return (
    
    <>
    {
        ok && <CustomAlert history={history} pro={pro} date={date} r_id={r_id} si_id={si_id} inputs={inputs} co_discount={co_discount} promotionText={promotionText}/>
    }
    {
        no && <CustomAlert2 setPopup={setPopup} popup={popup} promotionText={promotionText}/>
    }
    {
        ex && <CustomAlert3 setPopup={setPopup} popup={popup} promotionText={promotionText}/>
    }
    {
        format && <CustomAlert_x setPopup={setPopup} popup={popup} promotionText={promotionText}/>
    }
    
    
    <TopTitle title={`${promotionText} 입력`}/>
    <Container>
        <div className="c_pad">
            <h5 className="font-weight-bold mb-3">{promotionText}를 입력해주세요.</h5>
            <div className="c_flex c_boxshadow">
                <div className="col">
                    <input name="num1" type="text" className="c_border" value={inputs} onChange={onChange} autoComplete="off" />
                </div>
            </div>
            <div className="c_flex">
                <div className="c_certify my-3">{promotionText}를 - 없이 입력해주세요</div>
            </div>
            <div className="btn btn-primary c_coupon_btn r_btnsize" onClick={onClick}>등록</div>
            <div>
                <span className="btn btn-primary r_btnsize mt-3" onClick={goBack}>뒤로가기</span>
            </div>
        </div>
        
    </Container>
    </>
    
  );
}

export default RepInsert;